module.exports = __webpack_public_path__ + "img/form_attachment.d14d60f9.svg";